import styled from 'styled-components';
import PropTypes from 'prop-types';
import MotifTable from '@ey/motif-react-wrapper/Table';
import React, {useCallback} from 'react';
import {isValidFunction} from '../../../util/utils';

MotifTableWrapper.propTypes = {
	className: PropTypes.string
};

MotifTableWrapper.defaultProps = {
	className: 'StyledMotifTableWrapper'
};

export default function MotifTableWrapper(props) {
	const {className} = props;

	const handleOnGridReady = useCallback((params) => {
		document.querySelector('.ag-body-viewport').classList.add('customScrollbar');

		if (document.querySelector(`section.${className}`)) {
			document.querySelector(`section.${className}`).classList.add('customScrollbar');
		}

		if (isValidFunction(props.onGridReady)) {
			props.onGridReady(params);
		}
	}, []);

	return (
		<section className={className}>
			<StyledMotifTable {...props} onGridReady={handleOnGridReady} />
		</section>
	);
}

const StyledMotifTable = styled(MotifTable)`
	margin-top: var(--px-20);
	.ag-body-viewport.ag-layout-auto-height {
		margin-bottom: var(--px-30);
	}
	.AGGridWrapperSection .ag-root-wrapper {
		background: transparent;
	}
	.AGGridWrapperSection .ag-overlay-no-rows-wrapper {
		border: var(--px-1) solid var(--neutrals-200);
	}
	.AGGridWrapperSection .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected) {
		border: none;
	}
	.AGGridWrapperSection input[class^='ag-'][type='button']:focus,
	.AGGridWrapperSection button:focus {
		box-shadow: none !important;
	}
	.motif-table .ag-header-viewport:after {
		width: var(--px-1);
	}
	.motif-table .ag-body-viewport:after {
		width: 0;
	}
	.motif-table .motif-table-header-renderer div {
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.motif-table .motif-table-end-component-renderer {
		overflow: hidden;
		text-overflow: ellipsis;
		display: block;
	}
	.motif-table .ag-cell,
	.motif-table .ag-header-cell {
		font-size: var(--px-14);
		font-weight: 400;
		padding: 0 var(--px-10);
	}
	.motif-table .ag-pinned-left-cols-container,
	.motif-table .ag-pinned-left-header {
		box-shadow: none;
	}
	.motif-table .ag-row-first,
	.motif-table .ag-row-even {
		background: var(--neutrals-00white);
	}
	.motif-table .ag-header {
		border-color: var(--neutrals-200) !important;
		border-right-color: var(--neutrals-200) !important;
		border-bottom-color: var(--neutrals-200) !important;
	}
	.motif-table .ag-pinned-left-header,
	.motif-table .ag-header-viewport,
	.motif-table .ag-header-cell {
		background-color: var(--neutrals-25);
	}
	.motif-table .ag-row {
		font-weight: normal;
		border-right: var(--px-1) solid var(--neutrals-200) !important;
	}
	.motif-table .ag-row-hover {
		font-weight: normal;
		background: var(--neutrals-25) !important;
		border-right: var(--px-1) solid !important;
	}
	.motif-table .ag-row-first {
		font-weight: normal;
		background: var(--neutrals-00white) !important;
	}
	.motif-table .ag-row-first.ag-row-hover {
		font-weight: normal;
		background: var(--neutrals-25) !important;
		border: var(--px-1) solid !important;
	}
	.motif-table .ag-row-even,
	.motif-table .ag-row-odd {
		background: var(--neutrals-00white) !important;
	}
	.motif-table .ag-pinned-left-cols-container .ag-row-even,
	.motif-table .ag-pinned-left-cols-container .ag-row-odd {
		border-right: none !important;
	}
	.motif-table .ag-pinned-left-cols-container,
	.motif-table .ag-pinned-left-header {
		margin-left: -1px;
	}
	.motif-table .ag-row-even.ag-row-hover,
	.motif-table .ag-row-odd.ag-row-hover {
		background: var(--neutrals-25) !important;
	}
	.motif-table .ag-row-selected,
	.motif-table .ag-row-even.ag-row-selected,
	.motif-table .ag-row-odd.ag-row-selected {
		background-color: var(--neutrals-100) !important;
	}
	.motif-table .ag-header-cell[col-id='accountName'] .motif-table-header-renderer {
		justify-content: flex-start !important;
	}
	.motif-table .ag-header-cell[col-id='accountName'] .motif-table-header-renderer {
		justify-content: flex-start;
	}
	.motif-table .ag-header-cell {
		&[col-id='threedots'] {
			&:hover {
				background-color: var(--neutrals-25) !important;
				cursor: default;
			}
		}
	}
	.motif-table-header-renderer {
		justify-content: flex-end;
	}
	.motif-table .motif-table-header-renderer .motif-table-header-icons svg {
		height: var(--px-18) !important;
		width: var(--px-18) !important;
	}
`;
